import { SvgIconProps } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";

export const IconSettingsGear = ({ sx, ...props }: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 20 20" sx={{ fill: "none", ...sx }}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.30005 9.9998C7.30005 8.5085 8.50875 7.2998 10 7.2998C11.4913 7.2998 12.7 8.5085 12.7 9.9998C12.7 11.4911 11.4913 12.6998 10 12.6998C8.50875 12.6998 7.30005 11.4911 7.30005 9.9998Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 10.8991V9.1C19 8.6032 18.5968 8.2 18.0991 8.2H16.0354C15.9112 7.7815 15.7465 7.3801 15.5422 7.003L17.0002 5.545C17.3521 5.194 17.3521 4.6234 17.0002 4.2715L15.7276 2.9998C15.3766 2.6479 14.806 2.6479 14.4541 2.9998L12.997 4.4569C12.6199 4.2526 12.2185 4.0888 11.8 3.9637V1.9C11.8 1.4032 11.3968 1 10.8991 1H9.1009C8.6032 1 8.2 1.4032 8.2 1.9V3.9637C7.7815 4.0888 7.3801 4.2526 7.003 4.4569L5.5459 2.9998C5.194 2.6479 4.6234 2.6479 4.2724 2.9998L2.9998 4.2715C2.6479 4.6234 2.6479 5.194 2.9998 5.545L4.4578 7.003C4.2535 7.3801 4.0888 7.7815 3.9646 8.2H1.9009C1.4032 8.2 1 8.6032 1 9.1V10.8991C1 11.3968 1.4032 11.8 1.9009 11.8H3.9646C4.0888 12.2185 4.2535 12.6199 4.4578 12.997L2.9998 14.4541C2.6479 14.806 2.6479 15.3757 2.9998 15.7276L4.2724 16.9993C4.6234 17.3512 5.194 17.3512 5.5459 16.9993L7.003 15.5422C7.3801 15.7465 7.7815 15.9103 8.2 16.0354V18.0991C8.2 18.5968 8.6032 19 9.1009 19H10.8991C11.3968 19 11.8 18.5968 11.8 18.0991V16.0354C12.2185 15.9103 12.6199 15.7465 12.997 15.5422L14.4541 16.9993C14.806 17.3512 15.3766 17.3512 15.7276 16.9993L17.0002 15.7276C17.3521 15.3757 17.3521 14.806 17.0002 14.4541L15.5422 12.997C15.7465 12.6199 15.9112 12.2185 16.0354 11.8H18.0991C18.5968 11.8 19 11.3968 19 10.8991Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
